import { Component } from '@angular/core';

@Component({
	moduleId: module.id,
	selector: 'dashboard',
	templateUrl: 'dashboard.html',
	styleUrls: ['dashboard.scss'],
})

export class DashComponent{}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.component.ts